export const CROSS_SELL_SHAKE_FREQUENCY = "cross-sell-shake-frequency";
export const SHAKE_ANIMATION_TIMEOUT = 2000;

export const CROSS_SELL_M2_CAROUSEL_PADDING = {
    top: 16,
    left: 16,
    right: 16,
    bottom: 16,
};

export const lottieProps = {
    loop: false,
    forwardSpeed: 1,
    backwardSpeed: 1,
    playIfVisible: true,
};

export const CROSS_SELL_HEADER_ICON_DIMENSIONS = {
    HEIGHT: "15px",
    WIDTH: "14px",
};

export const MAGIC_ITEMS_TYPE = "MAGIC_ITEMS";

export const MAGIC_ITEMS_LOCKED_HEADER_ICON_DIMENSIONS = {
    HEIGHT: "32px",
    WIDTH: "32px",
};

export const THATS_ALL_IMAGE_ID = "Surprise%20Deals/Thats%20all%20for%20now!.png";
export const THATS_ALL_ALT_TEXT = "That's all for now!";
export const THATS_ALL_IMAGE_DIMENSIONS = {
    WIDTH: 75,
    HEIGHT: 72,
};

export const LINE_FOR_POPUP_IMAGE_ID = "Surprise%20Deals/line%20for%20popup.png";

export const UNLOCK_POPUP_MESSAGE = "Add items worth ₹{0} to unlock\nSurprise Deals";
export const EXPLORE_ITEMS_FROM_MENU = "Explore items from menu";

export const CROSS_SELL_HEADER_PADDING = {
    bottom: 8,
};

export const SURPRISE_DEALS_TITLE = "SURPRISE DEALS";
export const MAGIC_ITEMS_INLINE_ICON_KEY = "magic-items-inline-icon";
